<template>
  <div class="shopinfo-box">
    <a-card :bordered="false">
      <div class="shopinfo-content">
        <a-row>
          <quill-editor
            v-model="content"
            ref="myQuillEditor"
            :options="editorOption"
          ></quill-editor>
        </a-row>
        <a-row>
          <div class="btn-box">
            <a-button type="primary" @click="sub">提交</a-button>
          </div>
        </a-row>
      </div>
    </a-card>
  </div>
</template>

<script>
import { SETTING_query, SETTING_update } from "@/api/setting";
export default {
  data() {
    return {
      siteInfo: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["clean"]
          ]
        },
        theme: "snow"
      },
      content: ""
    };
  },
  created() {},
  mounted() {
    this.getInfo({ type: "haodesc" });
  },
  methods: {
    getInfo: function(_obj) {
      console.log(_obj);
      SETTING_query(_obj)
        .then(response => {
          this.content = decodeURIComponent(response.res.html);
        })
        .catch(() => {});
    },
    sub: function() {
      SETTING_update({
        type: "haodesc",
        info: { html: encodeURIComponent(this.content) }
      })
        .then(response => {
          console.log(response.res);
          if (response.status === 0) {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          } else {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.shopinfo-content {
  .btn-box {
    margin-top: 30px;
  }
  form textarea.ant-input {
    min-height: 500px;
  }
}
</style>
